import { mapAddressFromDto } from '../address/helpers';
import { CaseMaterialStatus } from './models';
// EFKT-MOCK: shared by every ICase mapper below — see the field comments on ICase in models.ts.
function mockCaseFields() {
    return {
        isArchived: false,
        materialStatus: CaseMaterialStatus.Active,
        hasMaterials: true,
    };
}
/**
 * `categories`/`orderStatus` aren't on the wire yet (`ICaseMockableFieldsDto` declares them purely
 * for forward-compat), but once BE adds them it's expected to send the same values Datahub's own
 * `CaseCategoryDtoType`/`OrderStatusDtoType` do — see `datahub/cases/helpers.ts`'s
 * `mapCaseFromDatahubCase`, which already casts the same way in the other direction. So this reads
 * straight off the DTO rather than mocking a fixed value: `undefined` today (the field isn't sent),
 * a real value the moment BE ships it, with zero mapper change needed then.
 */
function mapCaseCategoriesAndStatus({ categories, orderStatus }) {
    return {
        categories: categories,
        orderStatus: orderStatus,
    };
}
export function mapCasePropertyFromDto({ type, livingArea, basementArea, floors, }) {
    return {
        type,
        livingArea,
        basementArea,
        floors,
    };
}
export function mapCaseContactFromDto({ name, role, phone, email }) {
    return {
        type: role,
        name,
        phone,
        email,
    };
}
export function mapCaseFromDto(dto) {
    const { id, reference, createdAt, updatedAt, branchName, address } = dto;
    return {
        id,
        reference,
        createdAt: new Date(createdAt),
        updatedAt: new Date(updatedAt),
        address: (address === null || address === void 0 ? void 0 : address.addressFull) || '',
        addressObj: address && mapAddressFromDto(address),
        property: address && mapCasePropertyFromDto(address),
        departmentName: branchName,
        sourceBackend: 'efkt',
        ...mockCaseFields(),
        ...mapCaseCategoriesAndStatus(dto),
    };
}
/** `GET /api/cases/{caseId}` — see the "genuine superset" note on `ICaseDetailDto`. */
export function mapCaseFromDetailDto(dto) {
    const { id, reference, createdAt, updatedAt, address, account, photographerNote } = dto;
    return {
        id,
        reference,
        createdAt: new Date(createdAt),
        updatedAt: new Date(updatedAt),
        address: (address === null || address === void 0 ? void 0 : address.addressFull) || '',
        addressObj: address && mapAddressFromDto(address),
        property: address && mapCasePropertyFromDto(address),
        departmentName: account === null || account === void 0 ? void 0 : account.name,
        departmentId: account === null || account === void 0 ? void 0 : account.id,
        clientId: account === null || account === void 0 ? void 0 : account.clientId,
        photographerComment: photographerNote,
        sourceBackend: 'efkt',
        ...mockCaseFields(),
        ...mapCaseCategoriesAndStatus(dto),
    };
}
/** @deprecated Use `mapCaseFromDetailDto` off `CasesApi.getCaseById` — kept for `getCaseCompany`. */
export function mapCaseDetailsFromDto({ id, company }) {
    return {
        id,
        branchId: company === null || company === void 0 ? void 0 : company.id,
        branchName: company === null || company === void 0 ? void 0 : company.name,
    };
}
export function mapUpdateCaseAddressParamsToDto(params) {
    return {
        street: params.street,
        houseNumber: params.buildingNumber || undefined,
        floorNumber: params.buildingFloor,
        apartmentNumber: params.buildingDoor,
        city: params.city,
        postalCode: params.zip,
        country: params.country || 'Denmark',
    };
}
